import { jsx as _jsx } from "react/jsx-runtime";
import { ENV } from '@/configurations/env';
import { IconLogo } from '@agentguru/components';
import styles from './CockpitRoute.module.scss';
export function CockpitRoute() {
    return (_jsx("button", { type: "button", className: styles.container, onClick: function () { return window.open(ENV.COCKPIT_URL, '_blank'); }, children: _jsx(IconLogo, { variant: "cockpit" }) }));
}
